(ns practitest.frontend.components2.dashboard.charts.protocol)

(defmulti render!
  "Render a chart to an SVG element."
  (fn [chart _ctx _svg-element] (:chart/type chart)))

(defmulti svg-for-export
  "Prepare svg before export to png | print
   Should rentrun clone of svg-element"
  (fn [chart _svg-element] (:chart/type chart)))

(defmulti transform-data
  "Transform raw chart data before rendering."
  :chart/type)

